import "./Infos.css";

export function Infos() {
  return (
    <div className="infos">
      <h1>Informações Precisas e Confiáveis</h1>
      <p>
        Acreditamos no poder da informação. Por isso oferecemos acesso fácil a
        recursos de saúde precisos e confiáveis. Nosso site é uma fonte
        abrangente de informações atualizadas sobre doenças tratamentos e estilo
        de vida saudável. Queremos capacitar você a tomar decisões informadas e
        assumir o controle da sua saúde.
      </p>
    </div>
  );
}
